import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import OrganismHero from '~/components/organisms/hero/hero.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  const imagesSize = [1673, 1159, 1909]

  return h(
    UiComponentWrapper,
    {
      class: 'enterprise-services',
    },
    () => [
      props.componentEnterpriseServices.services.map(
        ({ id, background }, index) =>
          h(UiComponentImage, {
            key: `enterprise-service-icon-${id}`,
            alt: background.alt,
            class: [
              'background',
              { active: props.enterpriseServicesActiveIndex === index },
            ],
            expectedSize: imagesSize[index],
            height: background.height,
            source: background.url,
            width: background.width,
          }),
      ),
      h(UiComponentContainer, { class: 'inner' }, () => [
        h(
          OrganismHero,
          {
            level: 2,
          },
          {
            heading: () =>
              props.record.title || props.componentEnterpriseServices.title,
            paragraph: () =>
              props.record.text || props.componentEnterpriseServices.text,
          },
        ),
        h(UiComponentWrapper, { class: 'menu' }, () => [
          h(UiComponentWrapper, { class: 'inner' }, () => [
            props.componentEnterpriseServices.services.map(
              ({ id, type }, index) =>
                h(
                  UiComponentWrapper,
                  {
                    key: `menu-item-${id}`,
                    class: [
                      'item',
                      { active: props.enterpriseServicesActiveIndex === index },
                    ],
                    onClick: () => {
                      props.callback(index)
                    },
                  },
                  () => type,
                ),
            ),
          ]),
        ]),
        h(UiComponentWrapper, { class: 'features' }, () => [
          props.componentEnterpriseServices.services.map(
            ({ id, items }, index) =>
              h(
                UiComponentWrapper,
                {
                  key: `enterprise-service-icon-${id}`,
                  class: [
                    'list',
                    { active: props.enterpriseServicesActiveIndex === index },
                  ],
                },
                () => [
                  items.map(
                    ({
                      id: featureId,
                      icon,
                      enterpriseTitle,
                      enterpriseText,
                      fallbackTitle,
                      fallbackText,
                    }) =>
                      h(
                        UiComponentWrapper,
                        {
                          key: `enterprise-service-feature-${featureId}`,
                          class: 'item',
                        },
                        () => [
                          h(UiComponentImage, {
                            class: 'head',
                            alt: icon.alt,
                            expectedSize: 24,
                            height: icon.height,
                            source: icon.url,
                            width: icon.width,
                          }),
                          h(UiComponentWrapper, { class: 'body' }, () => [
                            h(
                              UiComponentHeading,
                              {
                                as: 'paragraph',
                                level: 5,
                              },
                              () => enterpriseTitle || fallbackTitle,
                            ),
                            h(
                              UiComponentParagraph,
                              {},
                              () => enterpriseText || fallbackText,
                            ),
                          ]),
                        ],
                      ),
                  ),
                ],
              ),
          ),
        ]),
        h(
          AtomButton,
          {
            action: props.primaryButton.action,
            label: 'Services section CTA',
            size: 'l',
            to: props.primaryButton.to,
          },
          () => props.primaryButton.slot,
        ),
      ]),
    ],
  )
}

Functional.props = {
  callback: {
    required: true,
    type: Function,
  },
  componentEnterpriseServices: {
    required: true,
    type: Object,
  },
  enterpriseServicesActiveIndex: {
    required: true,
    type: Number,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
